enum WeaponSubclass {
  OneHandedAxe = 0,
  TwoHandedAxe = 1,
  Bow = 2,
  Gun = 3,
  OneHandedMace = 4,
  TwoHandedMace = 5,
  Polearm = 6,
  OneHandedSword = 7,
  TwoHandedSword = 8,
  Staff = 10,
  OneHandedExotic = 11,
  TwoHandedExotic = 12,
  FistWeapon = 13,
  Miscellaneous = 14,
  Dagger = 15,
  Thrown = 16,
  Spear = 17,
  Crossbow = 18,
  Wand = 19,
  FishingPole = 20
}

export default WeaponSubclass
